var map = {
	"./decidim/avatar-multiuser.png": 55196,
	"./decidim/brands/facebook.svg": 35442,
	"./decidim/brands/google.svg": 94867,
	"./decidim/brands/twitter-x.svg": 11824,
	"./decidim/cc-badge.png": 80078,
	"./decidim/decidim-logo.svg": 87102,
	"./decidim/default-avatar.svg": 81322,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 93918,
	"./decidim/icons.svg": 34525,
	"./decidim/pattern.png": 84090,
	"./decidim/placeholder-card-g.svg": 58711,
	"./decidim/placeholder-card-l.svg": 87500,
	"./decidim/placeholder.jpg": 70163,
	"./decidim/remixicon.symbol.svg": 98171,
	"./decidim/vendor/social-share-button/douban.svg": 62954,
	"./decidim/vendor/social-share-button/email.svg": 37895,
	"./decidim/vendor/social-share-button/facebook.svg": 77209,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 71963,
	"./decidim/vendor/social-share-button/hacker_news.svg": 68651,
	"./decidim/vendor/social-share-button/linkedin.svg": 59127,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 5488,
	"./decidim/vendor/social-share-button/pinterest.svg": 841,
	"./decidim/vendor/social-share-button/reddit.svg": 6169,
	"./decidim/vendor/social-share-button/telegram.svg": 98560,
	"./decidim/vendor/social-share-button/tumblr.svg": 34615,
	"./decidim/vendor/social-share-button/twitter.svg": 6870,
	"./decidim/vendor/social-share-button/vkontakte.svg": 24360,
	"./decidim/vendor/social-share-button/wechat.svg": 41299,
	"./decidim/vendor/social-share-button/whatsapp.svg": 12715,
	"./decidim/vendor/social-share-button/x.svg": 90719,
	"./decidim/vendor/social-share-button/xing.svg": 81881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16161;